import React from 'react';
import { Plus, Trash2 } from 'lucide-react';
import { CurriculumAddMenu } from './CurriculumAddMenu';
import { getLeafTopics } from '../utils/topicUtils';
import {
  planCreateUnitCompactButtonClass,
  planDestructiveCompactButtonClass,
} from '../planFloatingActionsTheme';

interface AddTopicsTreeActionsProps {
  onOpenCreateYourOwnWizard: () => void;
  selectedTopics?: any[];
  onAddTopics?: () => void;
  onDeleteTenantCustomCurriculumTopics?: () => void;
  className?: string;
}

/**
 * Compact Add Topics tree-column actions.
 * Create Your Own is always shown; Add To Student Curriculum appears for any selection;
 * Delete from catalog appears only when the caller supplies an eligibility-gated callback.
 */
export function AddTopicsTreeActions({
  onOpenCreateYourOwnWizard,
  selectedTopics = [],
  onAddTopics,
  onDeleteTenantCustomCurriculumTopics,
  className = '',
}: AddTopicsTreeActionsProps) {
  const hasSelectedTopics = selectedTopics.length > 0;
  const leafTopicsCount = getLeafTopics(selectedTopics).length;

  return (
    <div className={`flex flex-wrap items-center gap-2 ${className}`}>
      <CurriculumAddMenu
        onOpenCreateYourOwnWizard={onOpenCreateYourOwnWizard}
        variant="compact"
      />
      {hasSelectedTopics && onAddTopics && (
        <button
          type="button"
          className={planCreateUnitCompactButtonClass}
          onClick={onAddTopics}
        >
          <Plus size={14} />
          <span>Add To Student Curriculum ({leafTopicsCount})</span>
        </button>
      )}
      {hasSelectedTopics && onDeleteTenantCustomCurriculumTopics && (
        <button
          type="button"
          className={planDestructiveCompactButtonClass}
          onClick={onDeleteTenantCustomCurriculumTopics}
        >
          <Trash2 size={14} />
          <span>Delete from catalog ({leafTopicsCount})</span>
        </button>
      )}
    </div>
  );
}
